import { render } from "./AddNewUserToMyRestaurant.vue?vue&type=template&id=7a8566c0&scoped=true"
import script from "./AddNewUserToMyRestaurant.vue?vue&type=script&lang=js"
export * from "./AddNewUserToMyRestaurant.vue?vue&type=script&lang=js"

import "./AddNewUserToMyRestaurant.vue?vue&type=style&index=0&id=7a8566c0&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8566c0"]])

export default __exports__